import { Link } from "react-router-dom";

const cols = [
  {
    label: "Company",
    links: [
      { to: "/about", text: "About Us" },
      { to: "/case-studies", text: "Case Studies" },
      { to: "/contact", text: "Careers" },
      { to: "/contact", text: "Press" },
    ],
  },
  {
    label: "Product",
    links: [
      { to: "/services", text: "Cloud Orchestration" },
      { to: "/services", text: "DevOps Automation" },
      { to: "/services", text: "Zero-Trust Security" },
      { to: "/services", text: "Elastic Scaling" },
    ],
  },
  {
    label: "Resources",
    links: [
      { to: "/services", text: "Documentation" },
      { to: "/services", text: "Status" },
      { to: "/services", text: "Security" },
      { to: "/contact", text: "Support" },
    ],
  },
  {
    label: "Legal",
    links: [
      { to: "/", text: "Privacy" },
      { to: "/", text: "Terms" },
      { to: "/", text: "DPA" },
      { to: "/", text: "Cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-200 bg-white"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 mb-5">
              <span className="relative w-7 h-7 grid place-items-center border border-zinc-950">
                <span className="absolute inset-[3px] bg-blue-700" />
              </span>
              <span className="font-display font-black tracking-tight text-[17px]">
                Infranova
              </span>
            </div>
            <p className="text-sm text-zinc-600 max-w-xs leading-relaxed">
              Modern, enterprise-grade infrastructure. Built for the world&apos;s
              most ambitious operations.
            </p>
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-zinc-400 mt-8">
              EST. MAR 2026 — 50 ENGINEERS
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {cols.map((col) => (
              <div key={col.label}>
                <h4 className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-zinc-400 mb-5">
                  {col.label}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.text}>
                      <Link
                        to={l.to}
                        data-testid={`footer-${l.text.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-zinc-700 hover:text-zinc-950 transition-colors"
                      >
                        {l.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-200 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © 2026 Infranova Solutions, Inc. All rights reserved.
          </p>
          <p className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-zinc-400">
            All systems operational · 99.999% uptime
          </p>
        </div>
      </div>
    </footer>
  );
}
